import React, { useState } from 'react';
import { Music, Play, Pause, Volume2, Sparkles, Activity } from 'lucide-react';

export const MusicTherapyModule: React.FC = () => {
  const [bpm, setBpm] = useState(72);
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-violet-500/20 text-violet-300 text-xs font-bold rounded-full border border-violet-500/30">
            <Music className="w-3.5 h-3.5" /> Module 22: Music & Rhythmic Auditory Stimulation (RAS)
          </div>
          <h2 className="text-2xl font-black mt-2">Neurological Music Therapy & Gait Auditory Entrainment</h2>
        </div>
        <div className="text-right">
          <div className="text-2xl font-black text-violet-400 font-mono">{bpm} BPM</div>
          <div className="text-xs text-slate-400">Auditory Metronome Tempo</div>
        </div>
      </div>

      <div className="bg-slate-950 p-6 rounded-2xl border border-slate-800 space-y-4 text-center">
        <div className="text-4xl font-black font-mono text-violet-400">{bpm} Beats / Min</div>
        <div className="flex items-center justify-center gap-4">
          <button 
            onClick={() => setBpm(Math.max(40, bpm - 4))}
            className="px-4 py-2 bg-slate-900 border border-slate-800 rounded-xl text-xs font-bold"
          >
            - 4 BPM
          </button>
          <button 
            onClick={() => setIsPlaying(!isPlaying)}
            className={`px-6 py-3 rounded-xl font-bold text-xs flex items-center gap-2 shadow ${isPlaying ? 'bg-amber-500 text-slate-950' : 'bg-violet-600 text-white'}`}
          >
            {isPlaying ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
            {isPlaying ? 'Pause Rhythm' : 'Start Auditory Entrainment'}
          </button>
          <button 
            onClick={() => setBpm(Math.min(160, bpm + 4))}
            className="px-4 py-2 bg-slate-900 border border-slate-800 rounded-xl text-xs font-bold"
          >
            + 4 BPM
          </button>
        </div>
      </div>
    </div>
  );
};
